import { HttpRequest, HttpResponse } from '../interfaces/http'
import { ApiError } from './ApiError'
import { HttpStatusKind } from '../interfaces/HttpStatusKind'
import { getKindFromHttpStatusCode } from '../httpStatusCodes/getKindFromHttpStatusCode'
import { ErrorCategory } from '../interfaces/error/ErrorCategory.Enum'

/**
 * UnsupportedHttpResponseError error occurs when we receive an http error response
 * from the server that is outside the range of status codes supported by this
 * library.
 */
export class UnsupportedHttpResponseError extends ApiError {
  public readonly kind: HttpStatusKind

  constructor(args: {
    code: number;
    message: string;
    httpRequest: HttpRequest;
    httpResponse: HttpResponse;
    originalError: Error;
  }) {
    const kind = getKindFromHttpStatusCode(args.code)
    super({
      ...args,
      message: `Unsupported http response code: '${args.code}'.
      This library only handles http responses in 200, 400 and 500-range.`,
      category: ErrorCategory.RESPONSE_PROBLEM,
      excerptExtra: { code: `${args.code} (http response code)` },
    })
    Object.setPrototypeOf(this, UnsupportedHttpResponseError.prototype)
    this.kind = kind
  }

  public toJSON() {
    return JSON.stringify({ ...this.getBaseJSON(), kind: this.kind })
  }
}
